import {
	app,
	environments,
	environment,
	credentials,
	connections,
	transferDetails,
} from '../../../@xmcloud/core/messages/en';
import { goTo } from '../../../@xmcloud/core/routes/paths';

export type TabItems = {
	text: string;
	fnName: keyof typeof goTo;
};

export const projectTabItemsLegacy: TabItems[] = [
	{
		text: environments.environments,
		fnName: 'environments',
	},
	{
		text: app.details,
		fnName: 'projectDetails',
	},
];

export const projectTabItems: TabItems[] = [
	{
		text: environments.cmEnvironments,
		fnName: 'cmEnvironments',
	},
	{
		text: environments.editingHosts,
		fnName: 'ehEnvironments',
	},
	{
		text: app.details,
		fnName: 'projectDetails',
	},
];

export const transferTabItems: TabItems[] = [
	{
		text: transferDetails.status,
		fnName: 'transferStatus',
	},
	{
		text: transferDetails.details,
		fnName: 'transferDetails',
	},
];

export const commonEnvTabItems: TabItems[] = [
	{
		text: environment.deployment,
		fnName: 'deployments',
	},
	{
		text: environment.sites,
		fnName: 'sites',
	},
	{
		text: environment.details,
		fnName: 'details',
	},
	{
		text: environment.logs,
		fnName: 'cmInstanceLogTypes',
	},
	{
		text: environment.variables,
		fnName: 'variables',
	},
	{
		text: environment.devSettings,
		fnName: 'devSettings',
	},
];

export const commonEnvTabItemsLegacy: TabItems[] = [
	{
		text: environment.deployment,
		fnName: 'oldDeployments',
	},

	{
		text: environment.sites,
		fnName: 'oldSites',
	},
	{
		text: environment.details,
		fnName: 'oldDetails',
	},
	{
		text: environment.logs,
		fnName: 'oldCmInstanceLogTypes',
	},
	{
		text: environment.variables,
		fnName: 'oldVariables',
	},
	{
		text: environment.devSettings,
		fnName: 'oldDevSettings',
	},
];

export const envEHTabItemsLegacy: TabItems[] = [
	{
		text: environment.deployment,
		fnName: 'oldDeployments',
	},
	{
		text: environment.details,
		fnName: 'oldDetails',
	},
	{
		text: environment.logs,
		fnName: 'oldCmInstanceLogTypes',
	},
	{
		text: environment.variables,
		fnName: 'oldVariables',
	},
	{
		text: environment.devSettings,
		fnName: 'oldDevSettings',
	},
];

export const EHEnvironmentTabItems: TabItems[] = commonEnvTabItems.filter(
	(item: { fnName: string }) => item.fnName !== 'sites',
);

export const credentialsTabItems: TabItems[] = [
	{
		text: credentials.organization,
		fnName: 'organizationCredentials',
	},
	{
		text: credentials.environment,
		fnName: 'environmentCredentials',
	},
];

export const connectionsTabItems: TabItems[] = [
	{
		text: connections.sourceControl,
		fnName: 'sourceControl',
	},
	{
		text: connections.hosting,
		fnName: 'hosting',
	},
];
